import { Element } from '../types/enums';

// French display names — placeholder until the story locks the final names.
export const EMOTION_NAMES: Record<Element, string> = {
  joy: 'Joie',
  sadness: 'Tristesse',
  anger: 'Colère',
  fear: 'Peur',
  surprise: 'Surprise',
  disgust: 'Dégoût',
  neutral: 'Neutre',
};

export const EMOTION_COLORS: Record<Element, string> = {
  joy: '#ffcf3a',
  sadness: '#5ab3ff',
  anger: '#ff5a4a',
  fear: '#9b6dff',
  surprise: '#ff7ad9',
  disgust: '#66cc44',
  neutral: '#e8e8e8',
};

const SUPER_EFFECTIVE = 2;

// Fixed effectiveness chart: attacker emotion → damage multiplier vs a defender
// type. A missing pair is neutral (1). Asymmetric by design; placeholder values
// pending balance.
export const EMOTION_EFFECTIVENESS: Record<
  Element,
  Partial<Record<Element, number>>
> = {
  joy: { sadness: SUPER_EFFECTIVE },
  sadness: { anger: SUPER_EFFECTIVE },
  anger: { fear: SUPER_EFFECTIVE, disgust: SUPER_EFFECTIVE },
  fear: { joy: SUPER_EFFECTIVE },
  surprise: { sadness: SUPER_EFFECTIVE, fear: SUPER_EFFECTIVE },
  disgust: { joy: SUPER_EFFECTIVE, surprise: SUPER_EFFECTIVE },
  // No relationship to any type: neutral always deals x1, both as attacker
  // (this row) and as defender (no other row lists it).
  neutral: {},
};

// Damage multiplier of `attacker` against a defender carrying `defenderTypes`.
// Dual-type stacks multiplicatively (Pokémon-style). No type → neutral.
export function emotionEffectiveness(
  attacker: Element,
  defenderTypes: readonly Element[],
): number {
  let mult = 1;
  for (const t of defenderTypes) {
    mult *= EMOTION_EFFECTIVENESS[attacker][t] ?? 1;
  }
  return mult;
}
